<template>
  <v-app-bar
    flat
    color="rgba(0, 0, 0, 0)"
    style="font-family: sfTextMediumFont;"
  >
    <img
      :src="this.$config.tokenIconUrl"
      @click="returnGeneral"
      style="cursor:pointer"
      width="24"
      height="24"
    />
    <span
      style="cursor:pointer;font-size:18px;"
      @click="returnGeneral"
      class="ml-2 white--text"
      >{{ this.$config.alias }}</span
    >
    <v-spacer></v-spacer>
    <img
      :src="require(`@/assets/common_icon/ic_menu_white.svg`)"
      @click="drawerController"
      class="hidden-lg-and-up"
    />
  </v-app-bar>
</template>
<script>
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return { iconUrl: this.$config.tokenIconUrl };
  },
  computed: {
    ...mapState(["showError"])
  },
  methods: {
    ...mapMutations(["updateShowError"]),
    drawerController() {
      this.$emit("listenChild", { goal: "ControlDrawer", value: null });
    },
    returnGeneral() {
      if (this.showError) {
        this.updateShowError(false);
      }
      if (this.$router.currentRoute.name !== "general") {
        this.$router.push({ path: "/general" });
      }
    }
  }
};
</script>
<style scoped>
.tile_front {
  font: SF Pro Text Medium;
}
@font-face {
  /* font-properties */
  font-family: sfTextMediumFont;
  src: url("../../assets/font/SF-Pro-Text-Medium.ttf");
}
</style>
>
